import { render, staticRenderFns } from "./psychometricChatStatus.vue?vue&type=template&id=482aa4f1&scoped=true&"
import script from "./psychometricChatStatus.vue?vue&type=script&lang=js&"
export * from "./psychometricChatStatus.vue?vue&type=script&lang=js&"
import style0 from "./psychometricChatStatus.vue?vue&type=style&index=0&id=482aa4f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482aa4f1",
  null
  
)

export default component.exports